module.exports = __webpack_public_path__ + "img/1dcef8c.jpg";